<div class="wt-tooltip">
  <div class="wt-tooltip__container">
    <span class="wt-text-bold-m" [innerHTML]="text"></span>
  </div>
  <ng-container *ngIf="showCloseButton">
    <div class="wt-tooltip__close" (click)="close()"></div>
  </ng-container>
</div>
